import React from 'react';
import { connect } from 'react-redux';
import { setActiveDevice } from '../actions/device-link-actions';
import ReactTooltip from 'react-tooltip';

import styles from '../../../../stylesheet/css/header-builder/devices-link.css';
import tooltipStyles from '../../../../stylesheet/css/header-builder/tooltip.css';

export const DeviceLink = ({ tooltiptext, active, children, onClick }) => {
  const className = styles.item + (active ? ' ' + styles.active : '');

  if (active) {
    return (
      <div data-tip data-for={ 'tooltip-' + tooltiptext } className={className}>
        {children}
        <ReactTooltip id={ 'tooltip-' + tooltiptext } class={tooltipStyles.overwrite} effect='solid'>
          <span>{tooltiptext}</span>
        </ReactTooltip>
      </div>
    )
  }

  return (
    <a href="#" data-tip data-for={ 'tooltip-' + tooltiptext } className={className} onClick={e => {
      e.preventDefault();
      onClick();
    }}>
      {children}
      <ReactTooltip id={ 'tooltip-' + tooltiptext } class={tooltipStyles.overwrite} effect='solid'>
        <span>{tooltiptext}</span>
      </ReactTooltip>
    </a>
    
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    active: ownProps.device === state.model.activeDevice,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onClick: () => {
      dispatch(setActiveDevice(ownProps.device));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceLink);



// WEBPACK FOOTER //
// ./app/header-builder/components/DeviceLink.js